import React from 'react';
import Navbar from './Navbar/Navbar'
//import QuizAppScreen from './QuizAppScreen';

import QuizApp from './QuizApp';


function QuizScreen() {

  return (
    <div className="App">

      <QuizApp>
        <h1>Hello</h1>
      </QuizApp>
    </div>
  );
}


export default QuizScreen;
